import styled from 'styled-components'

export default styled.main`

	.custom-title {
		border-bottom: 1px solid lightgray;
		padding-bottom: 8px;
		margin: 70px 0 32px  0;
	}

`